import React, { useState } from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import Input from '../Elements/Input/Input';
import Button from '../Elements/Button/Button';
import {
	addVoucher,
	voucherInputChange,
	removeVoucher,
	updateKlarna,
	updatePaymentMethod,
} from '../../actions/checkout';
import { translate } from '../../utils/locale';
import s from './Voucher.scss';

const Voucher = ({ setup, checkout, ...props }) => {
	const [voucherShowing, toggleVoucher] = useState(false);

	const toggleVoucherHandler = (e) => {
		e.preventDefault();
		toggleVoucher((prevState) => !prevState);
		const $voucherToggle = e.currentTarget;
		window.setTimeout(() => {
			$voucherToggle.nextSibling.querySelector('input').focus();
			$voucherToggle.nextSibling.querySelector('input').setSelectionRange(0, 0);
		}, 0);
	};

	const addVoucherHandler = (e) => {
		e.preventDefault();
		props.addVoucher().then((action) => {
			if (action.type === 'UPDATE_SELECTION') {
				toggleVoucher(false);
				props.updateKlarna();
			}
			return action;
		}).catch((err) => console.log('DEBUG: voucher not added', err));
		props.updatePaymentMethod();
	};

	const removeVoucherHandler = (e) => {
		e.preventDefault();
		const voucherId = e.currentTarget.dataset.voucher;
		props.removeVoucher(voucherId).then(() => props.updateKlarna()).catch((err) => console.log('DEBUG: voucher not removed', err));
		props.updatePaymentMethod();
	};

	const onVoucherInputChange = (id, value) => {
		props.voucherInputChange(value);
		props.updatePaymentMethod();
	};

	const vouchersSet = (checkout?.selection?.discounts?.vouchers || []).length > 0 ? checkout.selection.discounts.vouchers.filter((v) => v.voucher.indexOf('donationdoctorswithoutborders') === -1) : [];

	return (
		<div>
			<a className={[s.voucher_title, (voucherShowing ? s.voucher_title__expanded : null)].join(' ')} href="#toggle-voucher" onClick={toggleVoucherHandler}>{translate(setup, 'checkoutVoucherCode')}</a>
			<form className={s.voucher_form} onSubmit={addVoucherHandler}>
				<Input id="voucherCode" type="text" value={checkout.vouchers.currentValue} inputChange={onVoucherInputChange} />
				{ checkout.vouchers.error && <div className={s.voucher_form_error}>{ translate(setup, 'checkoutVoucherError') }</div> }
				<Button variantClasses={['button__inverse']} type="submit" text={translate(setup, 'checkoutVoucherUse')} />
			</form>
			{
				vouchersSet.length > 0 && (
					<div className={s.voucher_added}>
						{
							vouchersSet.map((voucher) => (
								<div key={voucher.voucher} className={s.voucher_added_row}>
									<span>{ translate(setup, 'checkoutVoucherAdded') }:</span>
									<div>
										<span>{ voucher.voucher }</span>
										<a href="#removeVoucher" data-voucher={voucher.voucher} onClick={removeVoucherHandler}>{ translate(setup, 'remove') }</a>
									</div>
								</div>
							))
						}
					</div>
				)
			}
		</div>
	);
};

const mapState = (state, props) => ({ ...props });

export default hot(module)(connect(mapState, { addVoucher, voucherInputChange, removeVoucher, updateKlarna, updatePaymentMethod })(Voucher));
